<template>
  <div v-if="courseDetail.title">
    <div class="crumbs-navigate">
      <div class="wrapper">
        <div class="crumbs-navigate-text">
          <ct-button class="init-button" @click="$router.push({name: 'userCourses'})">
            <ct-icon style="font-size: 14px;" name="list" class="list-icon"></ct-icon>
          </ct-button>
          <span class="need-dark">My courses</span>
          <ct-icon name="mianbao" class="erji-icon"></ct-icon>
          <span style="max-width: calc( 100% - 180px );overflow: hidden;text-overflow: ellipsis;white-space: nowrap;word-break: break-word;display: inline-block;">{{ courseDetail.title }}</span>
        </div>
      </div>
    </div>
    <div class="wrapper usercourse-detail-container">
      <h2 class="usercourse-bigcourse-title">{{ courseDetail.title }}</h2>
      <div class="usercourse-bigcourse-info clearfix">
        <div class="usercourse-progress-box">
          <ct-progressBar :total="courseDetail.chapter.length" :current="courseDetail.end_subclass_count"></ct-progressBar>
        </div>
        <div class="usercourse-progress-num">
          {{ courseDetail.chapter.length > 1 ? courseDetail.chapter.length + ' Lessons' : '1 Lesson' }}
        </div>
        <div class="usercourse-download-prev-box">
          <ct-button
            size="medium"
            :disabled="!courseDetail.preview_materials"
            class="usercourse-download-prev-btn">
            <a v-if="courseDetail.preview_materials"
              :href="courseDetail.preview_materials"
              class="hidden-download-a"></a>
            <ct-icon style="margin-right: 8px;" name="download"></ct-icon>Preview material</ct-button>
        </div>
      </div>
      <div class="usercourse-subclass-container">
        <div class="usercourse-subclass-info">
          Syllabus
          <div @click="goDetail" v-if="needBuy" class="usercourse-subclass-buy-remain-box">
            Buy remaining lessons
            <ct-icon name="jiantouyou"></ct-icon>
          </div>
        </div>
        <ul class="usercourse-subclass-list">
          <li
            class="usercourse-subclass-item"
            v-for="(item, index) in courseDetail.chapter"
            :key="item.chapter_id">
            <div class="usercourse-subclass-head clearfix">
              <span class="usercourse-subclass-index">{{ index + 1 }}</span>
              <h2 class="usercourse-subclass-title">{{ item.chapter_title }}</h2>
              <span class="status"
                :class="{
                'half': item.live_broadcast_state === 1,
                'notstart': item.live_broadcast_state === 2,
                'total': item.live_broadcast_state > 2
              }">{{ chapterStatus[item.live_broadcast_state] }}</span>
              <template v-if="item.price === 0 || item.state === 2">
                <template v-if="!getIsValid(item.deadline_at)">
                  <ct-button
                    size="mini"
                    v-if="item.live_broadcast_state === 1 || item.live_broadcast_state === 2"
                    :disabled="item.live_broadcast_state === 2"
                    class="usercourse-subclass-play-btn"
                    @click="goLive(item, 'live')"
                    style="width: 124px;"
                    type="primary">Join the class</ct-button>
                  <ct-button
                    size="mini"
                    v-else
                    style="width: 124px;"
                    @click="goLive(item, 'replay')"
                    class="usercourse-subclass-play-btn" type="secondary">Replay</ct-button>
                </template>
                <template v-else>
                  <ct-button
                    size="mini"
                    disabled
                    style="width: 124px;"
                    class="usercourse-subclass-play-btn"
                    type="secondary">Expired</ct-button>
                </template>
                <ct-button
                  size="mini"
                  :disabled="!item.course_ware "
                  class="usercourse-subclass-download-btn">
                  <a
                    v-if="item.course_ware" :href="item.course_ware"
                    class="hidden-download-a"></a>
                  <ct-icon style="margin-right: 8px;transform: scale(1.3);" name="xiazai"></ct-icon> Class notes</ct-button>
              </template>
              <template v-else>
                <span class="usercourse-subclass-price">${{ Number((item.price / 100).toFixed(2)) }}</span>
              </template>
            </div>
            <div class="usercourse-subclass-body clearfix">
              <div class="usercourse-subclass-time">
                <ct-icon style="vertical-align: text-bottom;" name="live_hui" multi-color></ct-icon>
                {{ getChapterTime(item) }}
              </div>
              <div class="usercourse-subclass-teacher">
                <ct-icon multi-color name="huatong" ></ct-icon>
                By {{ item.teachers }}
              </div>
              <div v-if="item.price === 0 || item.state === 2" class="usercourse-subclass-validtime">
                Valid until {{ getValidTime(item) }}
              </div>
            </div>
            <div class="usercourse-subclass-footer clearfix">
              <div v-if="item.price === 0 || item.state === 2" class="usercourse-subclass-validtime">
                Valid until {{ getValidTime(item) }}
              </div>
              <template v-if="item.price === 0 || item.state === 2">
                <template v-if="!getIsValid(item.deadline_at)">
                  <ct-button
                    size="mini"
                    v-if="item.live_broadcast_state === 1 || item.live_broadcast_state === 2"
                    :disabled="item.live_broadcast_state !== 2"
                    class="usercourse-subclass-play-btn"
                    @click="goLive(item, 'live')"
                    style="width: 124px;"
                    type="primary">Join the class</ct-button>
                  <ct-button
                    size="mini"
                    v-else
                    style="width: 124px;"
                    @click="goLive(item, 'replay')"
                    class="usercourse-subclass-play-btn" type="secondary">Replay</ct-button>
                </template>
                <template v-else>
                  <ct-button
                    size="mini"
                    disabled
                    style="width: 124px;"
                    class="usercourse-subclass-play-btn"
                    type="secondary">Expired</ct-button>
                </template>
                <ct-button
                  size="mini"
                  :disabled="!item.course_ware "
                  class="usercourse-subclass-download-btn">
                  <a
                    v-if="item.course_ware" :href="item.course_ware"
                    class="hidden-download-a"></a>
                  <ct-icon style="margin-right: 8px;transform: scale(1.3);" name="xiazai"></ct-icon> Class notes</ct-button>
              </template>
              <template v-else>
                <span class="usercourse-subclass-price">${{ Number((item.price / 100).toFixed(2)) }}</span>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import { chapterStatus } from '@ca/constants/index'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'UserCourseDetail',
  data () {
    return {
      courseDetail: {},
      chapterStatus
    }
  },
  mounted () {
    let a = this.checkGoodsId(this.goods_id)
    if (!a) return
    api.getMycourseDetail({
      params: {
        class_id: this.goods_id
      }
    }).then(res => {
      if (res.data && res.data.code === 1) {
        this.courseDetail = res.data.data
      } else if (res.data.code === 90605) {
        this.$confirm({
          title: 'Warning',
          message: 'Sorry, you haven’t add this free course to My Courses so that you can not get access to this page.',
          confirmButtonText: 'Got it',
          cancelButton: false,
          handleAction: (confirmed, resolve, reject) => {
            this.$router.push({
              name: 'liveCourseDetail',
              params: {
                origin: this.goods_id
              }
            })
            resolve()
          },
          closed: () => {
            this.$router.push({
              name: 'liveCourseDetail',
              params: {
                origin: this.goods_id
              }
            })
          }
        })
      } else if (res.data.code === 90603) {
        this.$confirm({
          title: 'Warning',
          message: 'Sorry, you haven’t purchased this course so that you can not get access to this page.',
          confirmButtonText: 'Got it',
          cancelButton: false,
          handleAction: (confirmed, resolve, reject) => {
            this.$router.push({
              name: 'liveCourseDetail',
              params: {
                origin: this.goods_id
              }
            })
            resolve()
          },
          closed: () => {
            this.$router.push({
              name: 'liveCourseDetail',
              params: {
                origin: this.goods_id
              }
            })
          }
        })
      } else {
        this.$confirm({
          title: 'Error',
          message: 'Sorry, this course doesn\'t exist.',
          confirmButtonText: 'Got it',
          cancelButton: false,
          handleAction: (confirmed, resolve, reject) => {
            this.$router.push({ name: 'live' })
            resolve()
          },
          closed: () => {
            this.$router.push({ name: 'live' })
          }
        })
      }
    })
  },
  methods: {
    getChapterTime (item) {
      const str = `${moment(item.begin_at * 1000).format('HH:mm')} - ${moment(item.end_at * 1000).format('HH:mm MMM Do, ddd')}`
      return str
    },
    getValidTime (item) {
      const str = moment(item.deadline_at * 1000).format('HH:mm,MMMM DD,YYYY')
      return str
    },
    getIsValid (time) {
      if ((new Date().getTime() / 1000) < time) {
        return false
      } else {
        return true
      }
    },
    goDetail () {
      this.$router.push({
        name: 'liveCourseDetail',
        params: {
          origin: this.goods_id
        }
      })
    },
    getAppend (str) {
      let a = str.split('.')
      return a[a.length - 1]
    },
    goLive (item, target) {
      if (target === 'live') {
        this.$router.push({
          name: 'live-broadcast',
          params: {
            liveId: this.goods_id,
            subId: item.chapter_id
          }
        })
      } else if (target === 'replay') {
        this.$router.push({
          name: 'live-replay',
          params: {
            liveId: this.goods_id,
            subId: item.chapter_id
          }
        })
      }
    },
    checkGoodsId (val) {
      if (isNaN(Number(val))) {
        this.$confirm({
          title: 'Warning',
          message: 'No this course! Please check and comfirm.',
          handleAction: (confirmed, resolve, reject) => {
            this.$router.push({ name: 'userCourses' })
            resolve()
          },
          closed: () => {
            this.$router.push({ name: 'userCourses' })
          }
        })
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    ...mapGetters(['isAdminRole']),
    goods_id () {
      return this.$route.params.goods_id
    },
    needBuy () {
      if (!this.courseDetail.chapter) return false
      if (this.isAdminRole) return false
      let a = 0
      this.courseDetail.chapter.forEach(el => {
        if (el.price === 0 || el.state === 2) {
          a += 1
        }
      })
      if (a < this.courseDetail.chapter.length) return true
      return false
    }
  },
  watch: {
    goods_id (val) {
      this.checkGoodsId(val)
    }
  }
}
</script>

<style lang="scss" scoped>
  $navigate-height: 76px;
  $mianbao-height: 46px;
  @mixin overflowTextStyle($lines) {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: $lines;
    line-clamp: $lines;
    -webkit-box-orient: vertical;
  }
  .crumbs-navigate{
    position:fixed;
    z-index: 1100;
    width: 100%;
    top: $navigate-height;
    background: #fff;
    box-shadow:0px 2px 14px 0px rgba(79,117,162,0.07);
    font-size:14px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    color:rgba(186,196,206,1);
    &-text{
      font-size:14px;
      font-family:SFProDisplay-Regular;
      font-weight:400;
      color:#BAC4CE;
      padding: 12px 0;
      line-height:22px;
      overflow: hidden;
      > * {
        float: left;
        height: 22px;
        line-height: 22px;
      }
    }
    .need-dark {
      color: #1A3D5E;
    }
    .init-button{
      padding: 0;
    width: auto;
    min-width: auto;
    height: auto;
    }
    .list-icon{
      margin-right: 8px;
      color:#1A3D5E;
      cursor: pointer;
      font-size: 20px;
      vertical-align: middle;
    }
    .erji-icon{
      vertical-align: middle;
      margin: 0 14px;
    }
    .switcher-container{
      height: 32px;
      position:absolute;
      line-height: 32px;
      right: 0;
      top: 7px;
    }
  }
  .usercourse-detail-container {
    margin-top: 86px;
    color: #1A3D5E;
    .usercourse-bigcourse-title {
      font-size:24px;
      font-family:SFProDisplay-Medium,SFProDisplay;
      font-weight:500;
      color:rgba(26,61,94,1);
      line-height:32px;
      margin-bottom: 6px;
      @include overflowTextStyle(2)
    }
    .usercourse-bigcourse-info {
      margin-bottom: 40px;
      .usercourse-progress-box {
        float: left;
        width: 65%;
      }
      .usercourse-progress-num {
        float: left;
        padding-top: 8px;
        line-height: 48px;
        margin-left: 16px;
        font-size:12px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(26,61,94,1);
      }
      .usercourse-download-prev-box {
        float: right;
        padding-top: 8px;
        line-height: 48px;
        .usercourse-download-prev-btn {
          background:rgba(55,202,215,0.1);
          color: #37CAD7;
          position: relative;
          &:disabled {
            background:rgba(247,251,255,1);
            color: rgba(26,61,94,.16);
            i {
              color: rgba(26,61,94,.16);
            }
          }
          .hidden-download-a {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border: none;
            outline: none;
            background: transparent;
          }
        }
      }
    }
    .usercourse-subclass-container {
      padding: 16px 40px;
      border:1px solid rgba(241,246,252,1);
      border-radius:2px;
      margin-bottom: 80px;
      .usercourse-subclass-info {
        font-size:16px;
        font-weight:500;
        color:rgba(163,177,191,1);
        line-height:19px;
        padding: 14px 0;
        .usercourse-subclass-buy-remain-box {
          float: right;
          font-size:14px;
          font-family:SFProText-Medium,SFProText;
          font-weight:500;
          height: 19px;
          line-height: 19px;
          color: #37CAD7;
          cursor: pointer;
          i {
            transform: translateX(0px);
            transition: all .2s;
          }
          &:hover {
            i {
              transform: translateX(5px);
            }
          }
        }
      }
      .usercourse-subclass-list {
        .usercourse-subclass-item {
          padding: 16px 0;
          border-top: 1px solid rgba(241,246,252,1);
          .usercourse-subclass-head {
            position: relative;
            padding-left: 50px;
            margin-bottom: 12px;
            font-size:16px;
            font-weight:400;
            color:rgba(26,61,94,1);
            vertical-align: text-top;
            line-height:19px;
            .usercourse-subclass-index {
              position: absolute;
              left: 0;
              top: 0;
              padding: 4px 14px;
              font-size:14px;
              font-family:SFProDisplay-Regular,SFProDisplay;
              font-weight:400;
              color:rgba(26,61,94,1);
              line-height:12px;
              background:rgba(239,244,250,1);
              border-radius:11px;
            }
            .usercourse-subclass-title {
              float: left;
              font-size:16px;
              font-family:SFProDisplay-Regular,SFProDisplay;
              font-weight:400;
              color:rgba(26,61,94,1);
              max-width: 53%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .status {
              float: left;
              margin-left: 8px;
              padding: 3px 6px;
              border-radius:2px;
              font-size:12px;
              font-family:SFProDisplay-Regular,SFProDisplay;
              font-weight:400;
              line-height:14px;
              &.notstart {
                background:rgba(254,249,238,1);
                color:rgba(250,203,88,1);
              }
              &.half {
                background:rgba(235,249,250,1);
                color:#37CAD7;
              }
              &.total {
                background: #EFF4FA;
                color: #A3B1BF;
              }
            }
            .usercourse-subclass-download-btn {
              float: right;
              background:rgba(247,251,255,1);
              position: relative;
              i {
                color: #1A3D5E;
              }
              &:disabled {
                color: rgba(26,61,94,.16);
                i {
                  color: rgba(26,61,94,.16);
                }
              }
              .hidden-download-a {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                border: none;
                outline: none;
                background: transparent;
              }
            }
            .usercourse-subclass-play-btn {
              float: right;
              margin-left: 16px;
            }
            .usercourse-subclass-price {
              float: right;
              font-size:14px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              color:rgba(163,177,191,1);
              height: 32px;
            }
          }
          .usercourse-subclass-body {
            padding-left: 50px;
            .usercourse-subclass-time {
              float: left;
              margin-right: 32px;
              font-size:14px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height:14px;
              svg {
                width: 31px;
                height: 18px;
                margin-right: 8px;
              }
            }
            .usercourse-subclass-teacher {
              float: left;
              svg {
                margin-right: 6px;
              }
              font-size:14px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height:18px;
            }
            .usercourse-subclass-validtime {
              float: right;
              font-size:12px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height:20px;
            }
          }
          .usercourse-subclass-footer {
            display: none;
            margin-top: 18px;
            padding-left: 50px;
            line-height: 32px;
            .usercourse-subclass-validtime {
              float: left;
              font-size:12px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height:32px;
            }
            .usercourse-subclass-play-btn {
              float: right;
              margin-left: 16px;
            }
            .usercourse-subclass-download-btn {
              float: right;
              background:rgba(247,251,255,1);
              position: relative;
              i {
                color: #1A3D5E;
              }
              &:disabled {
                color: rgba(26,61,94,.16);
                i {
                  color: rgba(26,61,94,.16);
                }
              }
              .hidden-download-a {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                border: none;
                outline: none;
                background: transparent;
              }
            }
          }
          @media screen and (max-width: 1200px) {
            .usercourse-subclass-head {
              .usercourse-subclass-title {
                max-width: 40%;
              }
            }
          }
          @media screen and (max-width: 992px) {
            .usercourse-subclass-head {
              .usercourse-subclass-title {
                max-width: 80%;
              }
              .usercourse-subclass-download-btn {
                display: none;
              }
              .usercourse-subclass-play-btn {
                display: none;
              }
            }
            .usercourse-subclass-body {
              .usercourse-subclass-validtime {
                display: none;
              }
            }
            .usercourse-subclass-footer {
              display: block;
            }
          }
        }
      }
    }
  }
</style>
